import React from "react";
import { useNavigate } from "react-router-dom";

interface SubscriptionPlanProps {
  onPlanSelected?: () => void;
  onBack?: () => void;
}

const SubscriptionPlan: React.FC<SubscriptionPlanProps> = ({
  onPlanSelected,
  onBack,
}) => {
  const navigate = useNavigate();

  const handleStartTrial = () => {
    // Here need to handle the subscription logic
    if (onPlanSelected) {
      onPlanSelected();
    } else {
      navigate("/leads");
    }
  };

  return (
    <div className="w-full max-w-[480px] p-6 rounded-2xl border border-lighterGray login-box-shadow h-fit">
      <div className="flex items-center gap-2 mb-4">
        {onBack && (
          <button
            onClick={onBack}
            className="text-darkGray hover:text-darkestSlate transition-colors"
          >
            <i className="fas fa-arrow-left text-lg"></i>
          </button>
        )}
        <h2 className="text-h1 font-bold text-darkestSlate">Sign Up</h2>
      </div>
      <div className="flex items-center gap-1">
        <span className="text-h3 text-darkGray">Already have an account?</span>
        <button
          type="button"
          className="text-h3 font-semibold text-darkBlue hover:underline"
          onClick={() => {
            window.location.hash = "";
          }}
        >
          Log In
        </button>
      </div>
      <div className="border-b border-lighterGray my-6"></div>

      <div className="border border-lightBlue rounded-2xl p-6 bg-lightestGray">
        <div className="mb-4">
          <h3 className="text-xl font-bold text-darkestSlate mb-2">
            Professional Plan
          </h3>
          <p className="text-sm text-darkGray mb-4">
            Everything you need to nurture, schedule, and track lead engagement
          </p>
          <div className="text-2xl font-bold text-darkestSlate mb-4">
            $ 20.00/mo.
          </div>
        </div>

        <div className="space-y-3 mb-6">
          <div className="flex items-center gap-3">
            <div className="w-4 h-4 bg-darkBlue rounded-full flex items-center justify-center">
              <i className="fas fa-check text-white text-xs"></i>
            </div>
            <span className="text-sm text-darkGray">
              Unlimited AI lead nurturing capabilities (Manual, Suggested, Autopilot)
            </span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-4 h-4 bg-darkBlue rounded-full flex items-center justify-center">
              <i className="fas fa-check text-white text-xs"></i>
            </div>
            <span className="text-sm text-darkGray">Scheduling features</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-4 h-4 bg-darkBlue rounded-full flex items-center justify-center">
              <i className="fas fa-check text-white text-xs"></i>
            </div>
            <span className="text-sm text-darkGray">Tracking</span>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            onClick={handleStartTrial}
            className="bg-darkBlue text-lightestGray px-6 py-3 rounded-3xl font-semibold hover:bg-mediumBlue transition-colors flex items-center gap-2"
          >
            Start 7-Day Free Trial
            <i className="fas fa-arrow-right text-sm"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlan;
